import { handleHttpRequest, http, type HttpResponse } from 'interfaces'

export interface BulkPositionChanges {
  title?: string
  typeId?: number
  statusId?: number
  cco?: number
  liaisonCode?: number
}

export interface BulkUpdateResult {
  updatedIds: number[]
}

/**
 * Apply one set of field changes to many selected positions in an org
 * (TI-4038). Only the fields the editor changed are sent.
 */
export async function bulkUpdatePositions (
  orgId: number,
  positionIds: number[],
  changes: BulkPositionChanges
): Promise<HttpResponse<BulkUpdateResult>> {
  return await handleHttpRequest(
    http.patch(`/api/v1/us/executives/orgs/${orgId}/positions/bulk/`, {
      positionIds,
      ...changes
    })
  )
}

/**
 * Persist the new drag-drop display order of an org's positions (TI-4039).
 * `order` is the position ids in their new visual order.
 */
export async function reorderPositions (
  orgId: number,
  order: number[]
): Promise<HttpResponse<{ order: Record<number, number> }>> {
  return await handleHttpRequest(
    http.patch(`/api/v1/us/executives/orgs/${orgId}/positions/reorder/`, { order })
  )
}
